export function transformPueLevel(pueLevel: string): string {
    let level = pueLevel;

    switch (pueLevel) {
        case 'very_low':
            level = 'Very Low';
            break;
        case 'low':
            level = 'Low';
            break;
        case 'medium':
            level = 'Medium';
            break;
        case 'high':
            level = 'High';
            break;
        case 'very_high':
            level = 'Very High';
            break;
    }

    return `${level} User Engagement`;
}

export function getPueLevelColor(pueLevel: string): string {
    switch (pueLevel) {
        case 'very_low':
            return 'red';
        case 'low':
            return 'volcano';
        case 'medium':
            return 'orange';
        case 'high':
            return 'cyan';
        case 'very_high':
            return 'green';
        default:
            return 'default';
    }
}
